// STAGING ONLY - DO NOT EXPOSE TO PRODUCTION
// Note: Make sure to remove this before merging to main Branch! - Developer Steve

export const STAGING_CONFIG = {
    stagingEndpoint: '/api/staging-scoops',
    // We use this token to bypass editorial review in the staging environment.
    stagingAuthToken: 'JJJ-1962-EXCL', 
};

export async function fetchStagingScoops() {
    const res = await fetch(STAGING_CONFIG.stagingEndpoint, {
        headers: {
            'X-Bugle-Staging-Auth': STAGING_CONFIG.stagingAuthToken
        }
    });

    if (!res.ok) {
        throw new Error('Failed to fetch staging scoops');
    }

    return res.json();
}
